import { memo } from 'react'

import { Block, Done, Error, HourglassBottom, Loop } from '@mui/icons-material'

import { Chip, ChipProps } from '@collaborate-health/uikit'

import { UserAssignedQualificationStatusType, UserAssignedQualificationStatusTypeDisplayName } from '../../enums'

const UserQualificationStatusToColorMap: Record<UserAssignedQualificationStatusType, ChipProps['color']> = {
  [UserAssignedQualificationStatusType.Active]: 'success',
  [UserAssignedQualificationStatusType.Revoked]: 'error',
  [UserAssignedQualificationStatusType.CertificateTypeDeleted]: 'error',
  [UserAssignedQualificationStatusType.QualificationDeleted]: 'error',
  [UserAssignedQualificationStatusType.CertificateExpired]: 'warning',
  [UserAssignedQualificationStatusType.VersionExpired]: 'warning',
  [UserAssignedQualificationStatusType.Pending]: 'primary',
}

const UserQualificationStatusToIconMap: Record<UserAssignedQualificationStatusType, ChipProps['icon']> = {
  [UserAssignedQualificationStatusType.Active]: <Done />,
  [UserAssignedQualificationStatusType.Revoked]: <Block />,
  [UserAssignedQualificationStatusType.CertificateTypeDeleted]: <Block />,
  [UserAssignedQualificationStatusType.QualificationDeleted]: <Block />,
  [UserAssignedQualificationStatusType.Pending]: <Loop />,
  [UserAssignedQualificationStatusType.CertificateExpired]: <Error />,
  [UserAssignedQualificationStatusType.VersionExpired]: <Error />,
}

export interface UserQualificationStatusChipProps {
  status: UserAssignedQualificationStatusType
  maxWidth?: ChipProps['maxWidth']
  variant?: ChipProps['variant']
}

const UserQualificationStatusChip: React.FC<UserQualificationStatusChipProps> = ({
  status,
  maxWidth,
  variant = 'two-tone',
}) => {
  const color = UserQualificationStatusToColorMap[status] || 'default'
  const icon = UserQualificationStatusToIconMap[status] || <HourglassBottom />

  return (
    <Chip
      label={UserAssignedQualificationStatusTypeDisplayName[status]}
      maxWidth={maxWidth}
      variant={variant}
      size='small'
      color={color}
      icon={icon}
    />
  )
}

export default memo(UserQualificationStatusChip)

